import React from 'react'
import { Provider } from "react-redux";

import { AppRouter } from './app/routes/AppRouter'
import { store, persistor } from './app/config/store'

import { PersistGate } from 'redux-persist/integration/react';

const ClimateChangeApp = () => {
  return (
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
        <AppRouter />
      </PersistGate>
    </Provider>
  )
}

export default ClimateChangeApp